import PropTypes from 'prop-types';

export const SplitShipRowDataPropType = PropTypes.shape({
  dataRowId: PropTypes.string.isRequired,
  name: PropTypes.string,
  sku: PropTypes.string,
  quantity: PropTypes.number.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
});

export const SplitShipRowFulfillmentPlanPropType = PropTypes.shape({
  fulfillmentPlanId: PropTypes.string.isRequired,
  orderGridStatus: PropTypes.string.isRequired,
});
